import React from 'react';

import scss from './ResponseItem.module.scss';

function TextItem({ message }) {
  return <pre className={scss.messageText}>{message}</pre>;
}

export default TextItem;
